const styles = (theme) => ({
  dialog: {
    boxSizing: "border-box",
    borderRadius: "2px",
    backgroundColor: theme.ModalBGColor,
    boxShadow: "2px 2px 4px black",
    maxWidth: "90%",
    flex: 1,
    userSelect: "none",
    fontWeight: "600",
    height: "90%",
  },
  dialogTitlestyle: {
    display: "flex",
    padding: "0 0 0 12",
    alignItems: "center",
    borderBottom: `1px solid ${theme.AppBGColor}`,
    justifyContent: "space-between",
    height: 46,
  },
  dialogTitle: {
    fontStyle: "normal",
    fontSize: theme.headerTextFontSize,
    lineHeight: "19px",
    color: theme.HeaderSelectedText,
  },
  dialogContent: {
    display: "flex",
    flexDirection: "column",
    fontSize: theme.headerTextFontSize,
    lineHeight: "19px",
    color: theme.TextColor,
    padding: "8 18 0 18",
  },
  tableContainer: {
    display: "flex",
    flexDirection: "column",
  },
  actionButton: {
    fontSize: theme.headerTextFontSize,
    textTransform: "none",
    borderRadius: "2px",
    margin: 0,
    width: "134px"
  },
  dialogAction: {
    margin: 0,
    padding: 18,
  },
  topContainer: {
    display: "flex",
    justifyContent: "space-between",
    margin: "0 0 12",
    flexWrap: "wrap"
  },
  bottomContainer: {
    border: `1px solid ${theme.AppBGColor}`,
    padding: "10 0 10 0",
  },
  gridContainer: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    border: `1px solid ${theme.AppBGColor}`,
  },
  closeButton: { color: theme.iconColor },
  headerStyle: {
    display: "flex",
    justifyContent: "space-between",
    border: `1px solid ${theme.AppBGColor}`,
    padding: "8px",
    borderRadius: "4px 4px 0 0",
    alignItems: "center"
  },
  headerLabel: {
    color: theme.HeaderSelectedText,
    fontSize: "14px",
    fontWeight: 600,
  },
  dataGrid: {
    flex: 1,
    border: `1px solid ${theme.AppBGColor}`,
    "& .dispatch-grid-active-button": {
      height: "20px",
      margin: "5px 0px",
      color: theme.palette.primary.main,
      border: `0.5px solid ${theme.palette.primary.main}`,
      backgroundColor: "transparent",
      fontSize: theme.textFontSize,
      width: "90px",
    },
    minHeight : 230
  },
  infoDriverContainer: { paddingTop: "20px", height: "50%" },
  stopDropdown: {
    display: "flex",
    alignItems: "center"
  },
  dropdownInput:{
    marginRight: 10
  },
  exportIcon:{
    padding: '10px 10px',
    borderLeft: `1px solid ${theme.AppBGColor}`,
    cursor: 'pointer',
    color: theme.iconColor,
  },
  iconStyle: {
    marginLeft: 30,
    marginRight: 10
  }
});
export default styles;
